import moment from 'moment';

export class RouteNameUtil {
  static getName(rName: string | null) {
    if (rName) {
      console.log(rName);
      switch (rName) {
        case '/p/Login':
          return '로그인';

        case '/p/MyPage':
          return '마이페이지';

        case '/p/AuthSignupTerm':
          return '회원가입';

        case '/p/GuestReservResult':
          return '비회원 예약확인';

        // /p/Login
        ///

        case '/p/introduce':
          return '클럽소개';

        case '/p/Awards':
          return '어워즈';

        case '/p/Tournament':
          return '토너먼트';

        case '/p/Photoview':
          return '포토뷰';

        case '/p/Notice':
          return '공지사항';

        case '/p/Newsroom':
          return '뉴스룸';

        /////

        case '/p/Infoguidance':
          return '이용안내';

        case '/p/Reservguidance':
          return '예약안내';

        case '/p/Feeguidance':
          return '요금안내';

        ///

        case '/p/Course':
          return '전체 코스';

        case '/p/Course/1':
          return 'EAST 코스';

        case '/p/Course/2':
          return 'WEST 코스';

        case '/p/Course/3':
          return 'NORTH 코스';

        ///

        case '/p/Sauna':
          return '사우나·락카';

        case '/p/Proshop':
          return '프로샵';

        case '/p/Golfpractice':
          return '어프로치 존';

        case '/p/Banquethall':
          return '연회장';

        ///

        case '/p/Restaurant':
          return '레스토랑';

        // GrBBQ 임시 히든처리(2025년 5월 8일까지)
        // case '/p/GrBBQ':
        //   return '그린사이즈 BBQ';

        case '/p/Starthouse':
          return '스타트하우스';

        ///

        case '/p/Preregistration':
          return '사전접수';

        case '/p/Waitingreception':
          return '잔여접수';

        case '/p/Realtimebooking':
          return '실시간예약';

        ///

        default:
          return rName;
      }
    } else {
      return '';
    }
  }
}
